import * as internal from "stream";
import { BaseEntity } from "yt-ng-framework";

export class RobaView extends BaseEntity{
    constructor(){
        super();
    };

    Sifra:string;
    Barcode:string;
    Naziv:string;
    RobnaGrupa:string;
    UnitOfMeasure:string;
    UnitOfMeasureCode:string;
    AltUnitOfMeasure:string;
    JmOdnos:number;
    Tarifa:string;
    AkciznaRoba:string;
    AkciznaRobaID:number;
    AkciznaRobaSifraRobneMarke:string;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Sifra=input.Sifra;
        this.Barcode=input.Barcode;
        this.Naziv=input.Naziv;
        this.RobnaGrupa=input.RobnaGrupa;
        this.UnitOfMeasure=input.UnitOfMeasure;
        this.UnitOfMeasureCode=input.UnitOfMeasureCode;
        this.AltUnitOfMeasure=input.AltUnitOfMeasure;
        this.JmOdnos=input.JmOdnos;
        this.Tarifa=input.Tarifa;
        this.AkciznaRoba=input.AkciznaRoba;
        this.AkciznaRobaID=input.AkciznaRobaID;
        this.AkciznaRobaSifraRobneMarke=input.AkciznaRobaSifraRobneMarke;

        return this;
    }

    Serialize(input:RobaView){
        return input;
    }

}